<template>
  <div class="display-flex flex-column align-items-start gap-16">
    <div class="border display-flex flex-column align-items-start width-full">
      <p class="compact-500-accent">
        My cart
      </p>
      <p class="text-400-default color-text-grey">
        No items yet
      </p>
    </div>

    <div class="width-full">
      <Button size="size.medium"
              class="width-full"
              color="bg.mojito"
      >
        <NuxtLink class="display-flex justify-center align-items-center compact-500-accent gap-8 cursor-pointer"
                  to="/collections"
        >
          Explore collections
          <IconMain icon="arrow-r-l"
                    :size="24"
          />
        </NuxtLink>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
<style lang="scss" scoped>

.btn-block {
  border-top: 1px solid #E9EAEC33;
}

.link {
  align-self: stretch;
  width: 100%;
  height: var(--control-500-size-single, 52px);
  transition: opacity 0.3s ease;
  border-radius: var(--control-500-radius, 2px);
  background: var(--bg-brand-mojito-primary);

  &:hover {
    opacity: 0.4;
  }

  span {
    width: 24px;
    height: 24px;
  }

  svg {
    width: 24px;
    height: 24px;
    rotate: 180deg;
  }
}

.color-text-grey {
  color: var(--content-secondary);
}

.border {
  padding-bottom: 30px;
  border-bottom: 1px solid rgb(233 234 236 / 20%);
}
</style>
